import styled from 'styled-components';
import { getSpacing, typography } from 'stylesheet';

export const EmptySearchApiResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
`;

export const EmptySearchApiResponseImage = styled.img`
  width: 155px;
  height: 116px;
`;

export const EmptySearchApiResponseTitle = styled.h3`
  margin-top: ${getSpacing(2)};
  ${typography.title_small};
  text-align: center;
`;
